// The single place a date becomes visible text. Every screen renders dates through
// this component — no screen formats one on its own, so the format changes here once.
//
// Display only: the value the server sent is never altered and nothing here is sent
// back. Date ENTRY is the mirror of this file and lives in DateField.js, which parses
// the same dd/mm/yyyy shape back into the ISO the API expects.
//
// Accepted inputs, all as they arrive from the API (mysql2 `dateStrings`):
//   'YYYY-MM-DD'            DATE column      → 21/07/2026
//   'YYYY-MM-DD HH:MM:SS'   DATETIME column  → 21/07/2026 (time is not shown)
//   'YYYY-MM'               CHAR(7) period   → 07/2026 (a month has no day)
// Anything else passes through untouched rather than being guessed at.
const EMPTY = '—';

export const formatDate = (value, fallback = EMPTY) => {
  if (!value) return fallback;
  const s = String(value);
  const day = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (day) return `${day[3]}/${day[2]}/${day[1]}`;
  const month = /^(\d{4})-(\d{2})$/.exec(s);
  if (month) return `${month[2]}/${month[1]}`;
  return s;
};

export default function DateText({ value, fallback = EMPTY }) {
  return <>{formatDate(value, fallback)}</>;
}

// A month as a heading rather than a data value: '2026-07' → 'יולי 2026'. Used for
// the period a screen is showing, where a numeric 07/2026 reads as a code. Month
// names come from the he-IL locale (same source as Money's currency formatting),
// and the date is built in UTC so the name can't slip a month across a timezone.
const monthFormatter = new Intl.DateTimeFormat('he-IL', {
  month: 'long', year: 'numeric', timeZone: 'UTC',
});

export const formatMonthLong = (month) => {
  const parts = /^(\d{4})-(\d{2})$/.exec(String(month || ''));
  if (!parts) return String(month || '');
  return monthFormatter.format(new Date(Date.UTC(Number(parts[1]), Number(parts[2]) - 1, 1)));
};
